import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';
import { TransformPlateNumber } from '@/functions/TransformPlateNumber';
import SubUserItem from './SubUserItem';
import { SubUser, userInfo } from '@/commonTypes';
import Button from '@/components/common/Button';
import MainIcons from '@/icons/main';
import { TRIGGERS } from '@/api/global';
import { useLayoutContext } from '@/context/LayoutContext';
import getMoreList from '@/functions/getMoreList';
import Api from '@/api';
import AppLink from '@/components/common/AppLink';

export default function SubUserModal() {
  const { setTrigger, setServerMessage, showError } = useLayoutContext();
  // let sample = {
  //   plate: TransformPlateNumber('ایران ۸۸ - ۴۱۴ ج ۸۷'),
  //   name: 'پریا رحیمی',
  //   id: 1,
  // };
  // const subUsers = Array.from({ length: 4 }, (_, index) => ({
  //   ...sample,
  //   id: index + 1,
  // }));
  const [subusers, setSubusers] = useState<SubUser[]>([]);
  const [subCount, setSubCount] = useState(0);
  const [syncLoading, setSyncLoading] = useState<string | number | undefined>('');
  const onDelete = (x: any) => {
    Api.removeSubuser(x?.sub_user_id)
      .then((res) => {
        setSubusers(subusers?.filter((m) => m.id != x?.id));
        setSubCount(subCount - 1);
        setServerMessage &&
          setServerMessage({
            text: res?.data?.response?.message ? res?.data?.response?.message : res?.data?.message,
            type: 'success',
          });
      })
      .catch((err) => {
        setServerMessage && setServerMessage({ text: err?.response?.data?.message, type: 'error' });
      });
  };
  const onOpen = (x: any) => {
    setTrigger(TRIGGERS.EDIT_PLATE_MODAL);
  };
  const onSync = (item?: SubUser) => {
    setSyncLoading(item?.id);
    Api.syncSubuser({ params: { sub_user_id: item?.sub_user_id } })
      .then((res) => {
        setServerMessage &&
          setServerMessage({
            text: res?.data?.response?.message ? res?.data?.response?.message : res?.data?.message,
            type: 'success',
          });
        setSyncLoading('');
        getSubuserList(0);
      })
      .catch((err) => {
        setServerMessage && setServerMessage({ text: err?.response?.data?.message, type: 'error' });
        setSyncLoading('');
      });
  };

  useEffect(() => {
    getSubuserList(0);
  }, []);
  const getSubuserList = (start = 0, limit = 3) => {
    Api.subUserList({ params: { start: start, limit: limit } })
      .then((res: any) => {
        setSubusers(getMoreList(start, res, subusers, 'sub_users'));
        setSubCount(res?.data?.count);
      })
      .catch((err: any) => {
        showError(err);
      });
  };
  console.log('subusers========', subusers);
  const getMoreSubusers = () => {
    getSubuserList(subusers?.length);
  };
  return (
    <div className={`${styles.container}`}>
      {subusers?.map((item, index) => (
        <SubUserItem
          item={item}
          name={item?.sub_user?.display_name ? item?.sub_user?.display_name : 'بی نام'}
          // plate={item?.plate}
          key={index}
          onDelete={onDelete}
          onSync={onSync}
          syncLoading={syncLoading}
          // onOpen={onOpen}
        />
      ))}
      {subusers && subusers?.length != 0 && subusers?.length < Number(subCount) && (
        <Button
          className={`btn btn-white mx-auto`}
          wrapperStyle="w-full flex "
          onClick={getMoreSubusers}
        >
          بیشتر
        </Button>
      )}
      <AppLink title=" افزودن کاربر جدید" href={`/sub-users`}>
        <Button
          className={`btn btn-blue squareButton w-full ${styles.button}`}
          wrapperStyle={`w-full`}
          // onClick={() => {
          //   setTrigger(TRIGGERS.ADD_SUBUSER);
          // }}
        >
          <MainIcons.plusIcon fill="var(--paper)" />
          افزودن کاربر جدید
        </Button>
      </AppLink>
    </div>
  );
}
